const DetalleCliente = () => import('@/app/views/clientes/views/DetalleCliente');
const ListadoClientes = () => import('@/app/views/clientes/views/ListadoClientes');
const NuevoCliente = () => import('@/app/views/clientes/views/NuevoCliente');

const clientesRoutes = [
  {
    path: 'clientes',
    redirect: '/gestion/clientes',
    name: 'Clientes',
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: [
      {
        path: '',
        name: 'Listado',
        component: ListadoClientes,
        meta: {
          auth: true,
        }
      },
      {
        path: '/clientes',
        name: '',
        component: NuevoCliente,
        meta: {
          auth: true
        },
        children: [
          {
            path: '/gestion/clientes/nuevo',
            name: 'Nuevo',
            meta: {
              auth: true
            }
          }
        ]
      },
      {
        path: '/clientes',
        name: '',
        component: DetalleCliente,
        meta: {
          auth: true,

        },
        children: [
          {
            path: '/gestion/clientes/:id',
            name: 'Detalle',
            meta: {
              auth: true,
              entidad: 'vados',
            }
          }
        ]
      },

    ]
  }
];

export default clientesRoutes;
